export const DEFAULT_NARS_STUDIO_URL = "http://127.0.0.1:3000/";

/** Only browser destinations belong here, never a local filesystem path. */
const isLoopback = (hostname: string) =>
  ["localhost", "127.0.0.1", "[::1]"].includes(hostname.toLowerCase());

export const getNarsStudioUrl = (
  configuredUrl?: string,
  crmHostname?: string,
): string | null => {
  try {
    const url = new URL(configuredUrl?.trim() || DEFAULT_NARS_STUDIO_URL);
    if (
      !["http:", "https:"].includes(url.protocol) ||
      url.username ||
      url.password
    ) {
      return null;
    }
    // Do not assume a remote viewer has Studio running locally. An explicitly
    // configured loopback URL still supports a hosted CRM with per-computer Studio.
    if (
      !configuredUrl?.trim() &&
      isLoopback(url.hostname) &&
      crmHostname &&
      !isLoopback(crmHostname)
    ) {
      return null;
    }
    return url.href;
  } catch {
    return null;
  }
};
